var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfeilZurueck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Zurueck__Icn/40px/Pfeil-Zurueck",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Zurueck__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Zurueck__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Zurueck__Color/Transp_00",
    transform: "matrix(-1 0 0 1 40 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Zurueck__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Zurueck__Group-Copy",
    transform: "matrix(-1 0 0 1 28.799 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L18,6 C18,9.78545172 14.9952166,12.8690987 11.2406498,12.995941 L11,13 L3.85394231,13 L8.84800677,17.2375071 L7.55401349,18.7624929 L0.482945676,12.7624929 C0.0436526045,12.3897403 0.0143663998,11.7322629 0.395087061,11.321547 L0.482945676,11.2375071 L7.55401349,5.23750715 L8.84800677,6.76249285 L3.85394231,11 L11,11 C13.6887547,11 15.8818181,8.87769329 15.9953805,6.21688962 L16,6 L16,0 L18,0 Z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Zurueck__Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeilZurueck);
export default __webpack_public_path__ + "static/media/Pfeil-Zurueck.443d053dccd4debed5961cbc30af47bc.svg";
export { ForwardRef as ReactComponent };